// src/pages/TestPage.tsx
// Thin wrapper: guards that a test is actually loaded before rendering
// TestSession. If someone navigates to /test directly with no active test,
// they're sent back home — same pattern as ExercisePage.

import { Navigate } from 'react-router-dom';
import { useTestStore } from '../stores/useTestStore';
import TestSession from '../components/test/TestSession';

export default function TestPage() {
  const phase = useTestStore((s) => s.phase);

  if (phase === 'idle') {
    return <Navigate to="/" replace />;
  }

  return <TestSession />;
}